// @flow
import { connect } from "react-redux";
import MessagesPageView from "./view";
import { fetchMonthlyPhotos, showMonth } from "../state/photos/actions";

export default connect(
    state => ({
        photos: state.photos.all
    }),
    dispatch => ({
        onFetchPhotos: () => dispatch(fetchMonthlyPhotos()),
        onShowPhotos: photoSummary => dispatch(showMonth(photoSummary))
    })
)(MessagesPageView);



// WEBPACK FOOTER //
// ./src/photos-page-view/index.js